export const ROLES = {
  ADMIN: 'Administrator',
  EDITOR: 'Editor',
  VIEWER: 'Viewer',
  ATTORNEY: 'Attorney',
};
